import SingleSectionElement from "./SingleSectionElement";

export default SingleSectionElement;